import { render, staticRenderFns } from "./mantenimiento-periodico-editar.vue?vue&type=template&id=578f0ffe&scoped=true&"
import script from "./mantenimiento-periodico-editar.vue?vue&type=script&lang=js&"
export * from "./mantenimiento-periodico-editar.vue?vue&type=script&lang=js&"
import style0 from "./mantenimiento-periodico-editar.vue?vue&type=style&index=0&id=578f0ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f0ffe",
  null
  
)

export default component.exports